import { createSelector } from 'reselect'

export const getElement = (state, props) => {
  return state['view-card'].elements.elementsById[props.id]
}

export const getIsCardArchived = (state, props) => {
  return state['view-board'].cards[props.cardContext.id].isArchived
}

export const getIsCollapsed = (state, props) => {
  return state.kanbo.localSettings['collapseCardElement-' + props.id]
}

export default () => createSelector(
  [getIsCardArchived, getElement, getIsCollapsed],
  (isCardArchived, element, isCollapsed) => ({
    isCardArchived,
    elementName: element.elementName,
    name: element.name,
    isBusy: element.isBusy,
    isCollapsed
  })
)
